export default {
  "buttons": {
    "readMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Read article"])},
    "loadMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show more articles"])}
  },
  "pagination": {
    "of": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["of"])},
    "loaded": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["articles loaded"])}
  }
}